import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    static targets = ["modal", "photosContainer"]
    static values = { url: String, invoiceItemId: Number }

    initialize() {
    }

    connect() {
        this.modalInstance = new Modal(this.modalTarget);
        // Слушаем событие от строк таблицы
        this.element.addEventListener("open-photos-modal", (event) => {
            this.loadPhotos();
            this.modalInstance.show();
        });
    }

    openModal (event) {
        this.invoiceItemIdValue = event.currentTarget.dataset.invoiceItemPhotosInvoiceItemIdValue;
        this.loadPhotos();
        this.modalInstance.show();
    }

    async loadPhotos() {

        this.photosContainerTarget.innerHTML = "";
        try {
            const response = await fetch(`/invoice_items/${this.invoiceItemIdValue}/photos`);
            const photos = await response.json();
            this.displayPhotos(photos)
        } catch (error) {
            console.error("Ошибка при загрузке фотографий:", error);
            this.photosContainerTarget.innerHTML = "<p>Ошибка загрузки фотографий</p>";
        }
    }

    displayPhotos(photos) {

        if (photos.length === 0) {
            this.photosContainerTarget.innerHTML = `
                <div class="flex-grow-1" style="max-width: 300px; min-width: 220px;">
                  <div class="card h-100 shadow-sm">
                    <i class="bi bi-image fs-1 text-muted"></i>
                    <p class="text-muted mt-2">Нет фотографий</p>
                  </div>
                </div>
              `;
            return;
        }

        this.photosContainerTarget.innerHTML = `
            ${photos.map(photo => `
                <div class="flex-grow-1" style="max-width: 300px; min-width: 220px;">
                    <div class="card h-100 shadow-sm">
                        <img 
                            src="${photo.url}" 
                            class="card-img-top" style="height: 200px; object-fit: cover"
                            loading="lazy"
                          >
                        <div class="card-body">
                         <p class="card-text small text-muted"> ${photo.filename} </p>
                      </div>
                    </div>
                </div>
            `).join('')}
        `;
    }

    closeModal() {
        this.modalInstance.hide();
        this.photosContainerTarget.innerHTML = "";
    }
}